import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_DELETE } from '../../../constants/api';
import { removeOrderedPart } from '../../../actions/coilovers/orderedParts/patchOrderedParts';

const deleteOrderedParts = createAsyncThunk('orderedParts/deleteOrderedParts',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await authSet(METHOD_DELETE, `/co/ordered_parts/${id}`);
      dispatch(removeOrderedPart(id));
      return id;
    } catch (error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  });

export default deleteOrderedParts;
